import { z } from 'zod';

const formBookingRangePickerSchema = z.object({
  serviceDivisionGroups: z.array(z.string()).min(1, {
    message: 'schemas:common.required'
  })
});

export default formBookingRangePickerSchema;
